import React from 'react';
import PropTypes from 'prop-types';

const CloseButton = ({ clientId, onClose, className }) => (
  <button
    type="button"
    onClick={onClose(clientId)}
    className={`bg-transparent white close-button ${className}`}
  >
    Close What-Ifs
  </button>
);

CloseButton.defaultProps = {
  className: '',
};

CloseButton.propTypes = {
  clientId: PropTypes.number.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default CloseButton;
